import React from "react";

import { useProgressBarContext } from "../ProgressBarView/context/ProgressBarContext";

import { ProgressBarWidget1 } from "./variants/version1/ProgressBarWidget1";
import { ProgressBarWidget2 } from "./variants/version1/ProgressBarWidget2";
import { ProgressBarWidget4 } from "./variants/version1/ProgressBarWidget4";
import { ProgressBar1 } from "./variants/version2/ProgressBar1";
import { ProgressBar2 } from "./variants/version2/ProgressBar2";
import { ProgressBar3 } from "./variants/version2/ProgressBar3";

export const ProgressBarFactory = () => {
  const { device } = useProgressBarContext();

  const variant = device.widget.variant;
  switch (variant) {
    case "progressBarWidget1":
      return <ProgressBarWidget1 />;
    case "progressBarWidget2":
      return <ProgressBarWidget2 />;
    case "progressBarWidget4":
      return <ProgressBarWidget4 />;
    case "progressBar1":
      return <ProgressBar1 />;
    case "progressBar2":
      return <ProgressBar2 />;
    case "progressBar3":
      return <ProgressBar3 />;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      console.error("Unrecognized progress bar widget: " + variant);
  }
};
